import { PropTypes } from 'prop-types';
import React from 'react';
import ReactPaginate from 'react-paginate';

class ResourceList extends React.Component {
    render() {
        let content = (
            <div
                className='resource-card-collection-wrapper'
                dangerouslySetInnerHTML={{__html: this.props.content}}
            />
        );

        let afterListing = null;
        if (this.props.isLoading) {
            content = (
                <div className='loading-throbber'>
                    <span className='text'>Loading...</span>
                    <div className='cssload-ball' />
                </div>
            );
        } else if (this.props.totalPages > 1) {
            afterListing = (
                <ReactPaginate
                    previousLabel={'Previous'}
                    nextLabel={'Next'}
                    breakLabel={'…'}
                    breakClassName={'break-me'}
                    forcePage={this.props.page - 1}
                    pageCount={this.props.totalPages}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={this.props.onClickPage}
                    containerClassName={'pagination'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
					hrefBuilder={O=>'/resources/page/' + O}
                />
            );
        }

        return (
            <div className='container'>
                {content}
                {afterListing}
            </div>
        );
    }
}

ResourceList.propTypes = {
    isLoading: PropTypes.bool,
    content: PropTypes.string,
    page: PropTypes.number,
    totalPages: PropTypes.number,
    onClickPage: PropTypes.func
};

export default ResourceList;
